<template>
  <div class="container">
    <BaseBreadcrumb
      v-if="getBreadcrumb"
      class="bg-white mt-4 ml-6"
      :breadcrumb="getBreadcrumb"
    />
    <div class="how-it-work">
      <Header />
      <ItemWorks />
      <LearnPrivately />
      <EveryStudent />
      <TutorSelection />
      <QualityPrice />
      <UnsureChoice />
    </div>
  </div>
</template>
<script>
import { renderHead } from '@helper/head/head-home'
import { mapGetters } from 'vuex'
import BaseBreadcrumb from '@design-system/base/breadcrumb/breadcrumb-pages'
import Header from '@/components/pages/how-it-works/header.vue'
import ItemWorks from '@/components/pages/how-it-works/item-works.vue'
import LearnPrivately from '@/components/pages/how-it-works/learn-privately.vue'
import EveryStudent from '@/components/pages/how-it-works/every-student.vue'
import TutorSelection from '@/components/pages/how-it-works/tutor-selection.vue'
import QualityPrice from '@/components/pages/how-it-works/quality-price.vue'
import UnsureChoice from '@/components/pages/how-it-works/unsure-choice.vue'

export default {
  name: 'HowItWork',
  components: {
    BaseBreadcrumb,
    Header,
    ItemWorks,
    LearnPrivately,
    EveryStudent,
    TutorSelection,
    QualityPrice,
    UnsureChoice
  },
  auth: false,
  layout: 'main',
  async asyncData ({ store }) {
    await store.dispatch('local/asyncDataHowItWorks')
  },
  head () {
    return renderHead({ meta: this.getMeta })
  },
  computed: {
    ...mapGetters('global', ['getMeta', 'getBreadcrumb'])
  },
  methods: {
    logggon (test) {
      console.log(333333, test)
    }
  }
}
</script>

<style lang="scss" scoped>
.how-it-work {
    @apply mx-auto mt-12 lg:mt-20;
}
</style>
